import { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const CACHE_KEY_SHOPS = "cachedShopsData";

const ShopsPage = () => {
  const auth = getAuth();
  const db = getFirestore();
  const navigate = useNavigate();

  // Load cached data instantly
  const [shops, setShops] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY_SHOPS)) || [];
    } catch {
      return [];
    }
  });

  const [loading, setLoading] = useState(shops.length === 0);

  useEffect(() => {
    const fetchShops = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const agentRef = doc(db, "affiliates", user.uid);
      const agentSnap = await getDoc(agentRef);

      if (agentSnap.exists()) {
        const agentData = agentSnap.data();
        if (agentData.assignedShops) {
          const shopDetails = await Promise.all(
            agentData.assignedShops.map(async (shopId) => {
              const shopRef = doc(db, "rentalShops", shopId);
              const shopSnap = await getDoc(shopRef);
              return shopSnap.exists()
                ? { id: shopId, ...shopSnap.data() }
                : null;
            })
          );
          const filteredShops = shopDetails.filter((shop) => shop !== null);
          setShops(filteredShops);
          localStorage.setItem(CACHE_KEY_SHOPS, JSON.stringify(filteredShops));
        }
      }
      setLoading(false);
    };

    fetchShops();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (shops.length === 0) return <Typography>No shops found.</Typography>;

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        My Shops
      </Typography>
      {shops.map((shop) => (
        <Card key={shop.id} sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6">{shop.name}</Typography>
            <Typography>{shop.location}</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/shop/${shop.id}`)}
            >
              View More
            </Button>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default ShopsPage;
